import { Route } from '@angular/router';
import { CustomerDisplayPageService } from './customer-display/customer-display-page.service';

export const appRoutes: Route[] = [
  {
    path: 'display/:code',
    loadComponent: () =>
      import('./customer-display/customer-display.component').then((m) => m.CustomerDisplayComponent),
    providers: [CustomerDisplayPageService],
  },
  {
    path: '',
    loadComponent: () => import('./map/map.component').then((m) => m.MapComponent),
  },
  {
    path: ':operator',
    loadComponent: () => import('./map/map.component').then((m) => m.MapComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
